











import { Component, Prop } from 'vue-property-decorator';
import { ProductUnitDto, ProductUnitsDto } from '@/api';
import Big from 'big.js';
import Vue from 'vue';
import { PriceService } from '@/util/PriceService';
import { PriceFormatter } from '@/util/PriceFormatter';

@Component
export default class DetailUnitSelector extends Vue {
  @Prop({required: true})
  public unitsInfo!: ProductUnitsDto;

  @Prop({required: true})
  public storagePrice!: Big;

  @Prop({required: true})
  public selectedUnit!: ProductUnitDto;

  get visibleUnits(): ProductUnitDto[] {
    return this.unitsInfo.units && this.unitsInfo.units.filter((unit: ProductUnitDto) => unit.isVisible);
  }

  public selectUnit(newUnit: ProductUnitDto): void {
    this.$emit('select-unit', newUnit);
  }

  public isSelected(unit: ProductUnitDto): boolean {
    return this.selectedUnit === unit;
  }

  public findUnitPriceString(unit: ProductUnitDto): string {
    const unitPrice = PriceService.findUnitPrice(unit, this.storagePrice);
    return PriceFormatter.formatPrice(unitPrice);
  }
}
